import { Grid, Card, Typography, Box, Button, IconButton } from "@mui/material";
import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Add from "../components/address/Add";
import Edit from "../components/address/Edit";
import Delete from "../components/address/Delete";
import { useAddress } from "../context/AddressContext";

const UserAddress = () => {
  const { addresses, DeleteData, user, setUser } = useAddress();
  const handleDelete = (id) => {
    DeleteData(id);
  };

  return (
    <Grid container spacing={1}>
      {addresses.map((adds, index) => {
        const { id, name, address, city, state, country, type } = adds;

        return (
          <Grid item md={6} key={index}>
            <Card variant="outlined" sx={{ padding: 2 }}>
              <Grid container spacing={2}>
                <Grid item md={2}>
                  <LocationOnIcon sx={{ fontSize: "2rem" }} />

                </Grid>
                <Grid item md={10}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", color: "rgb(79, 79, 79)" }}
                  >
                    {type}
                  </Typography>
                  <Box sx={{ marginTop: 1 }}>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        color: "green",
                        fontSize: "1rem", 
                        textTransform: "capitalize", 
                      }}
                    >
                      {name}
                    </Typography>

                    <Typography variant="body2">
                      <strong>Address:</strong> {address}
                    </Typography>
                    <Typography variant="body2">
                      <strong>City:</strong> {city}
                    </Typography>
                    <Typography variant="body2">
                      <strong>State:</strong> {state}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Country:</strong> {country}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", marginTop: 2 }}>
                    <Edit address={adds} />
                    <Delete onDelete={() => handleDelete(id)} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        );
      })}
      <Grid item md={6}>
        <Add />
      </Grid>
    </Grid>
  );
};

export default UserAddress;
